import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { magicLampsAnim } from './MagicLampsAnim';

export class MagicLampsSmoke extends View {
  private clouds: ImageScaleView[] = [];

  constructor(opts: ViewOpts) {
    super({ ...opts });

    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_01.png');
    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_02.png');
    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_03.png');
    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_01.png');
    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_02.png');
    this.addCloud('assets/ui/match2/magiclamps/magiclamps_cloud_03.png');
  }

  private addCloud(image: string) {
    this.clouds.push(
      new ImageScaleView({
        image,
        superview: this,

        visible: false,
        centerOnOrigin: true,
        width: 80,
        height: 80,
        scaleMethod: 'contain',
      }),
    );
  }

  public async playAnimation() {
    this.updateOpts({ visible: true });
    this.clouds.forEach((cloud) => {
      cloud.updateOpts({
        visible: true,
        x: 0,
        y: 0,
        scale: 1.5,
        opacity: 0,
      });
    });

    const rotation = Math.random() * Math.PI * 2;
    await Promise.all(
      this.clouds.map((cloud, i) => {
        const angle = Math.PI * 2 * (i / this.clouds.length) + rotation;
        const range = 80;
        const opacity = 1;
        const scale = 0;
        const x = Math.sin(angle) * range;
        const y = Math.cos(angle) * range;
        return magicLampsAnim(
          cloud,
          { x, y, opacity, scale },
          1000,
          animate.easeOutQuart,
        );
      }),
    );
    this.updateOpts({ visible: false });
  }
}
